<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="120"
    >
      <FormItem label="发布后的url" prop="url">
        <Input v-model="formValidate.url" placeholder="请填写发布后的url"></Input>
      </FormItem>

      <FormItem style="text-align: right">
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'

export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      classifyIds: [],
      tagIds: [],
      liveTypes: [],
      userIds: [],
      formValidate: {
        id: '',
        url: ''
      },
      ruleValidate: {
        url: [
          {
            required: true,
            message: '发布后的url需要填写',
            trigger: 'bulr'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
      this.$refs.fileInput.value = ''
    }
  },
  methods: {
    setEditData (data) {
      this.formValidate.id = data.id
      this.formValidate.url = data.video_url
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
